export default __webpack_public_path__ + "static/kdc-logo-8d29d99dae05deb210a9198aaa238b5c.png";